import type { ReactNode } from 'react'

/**
 * Romanian customer-support channels surfaced in the human-assistance pop-up.
 * `phoneHref` strips the display spacing so `tel:` reaches the dialer intact.
 */
export const LEANPAY_RO_SUPPORT = {
    faqUrl: 'https://help.leanpay.com/ro/knowledge',
    email: 'credit@leanpay.ro',
    phone: '+40 31 631 8800',
    phoneHref: '+40316318800',
} as const

export interface HelpContactLinkProps {
    children?: ReactNode
    className?: string
}

// Design renders the in-body contacts underlined at body weight, not bold.
export const helpContactLinkClasses = 'underline'
